import { addMonths, todayIso } from '@outsource/shared/dates';

/** The browser's "now". One seam so tests can pin it with `vi.setSystemTime`. */
export function now(): Date {
  return new Date();
}

/** Local calendar date, `YYYY-MM-DD`. */
export function today(): string {
  return todayIso(now());
}

/** The calendar month of today, `YYYY-MM`. */
export function currentPeriod(at: Date = now()): string {
  return todayIso(at).slice(0, 7);
}

/** The previous calendar month: the last finished month (Finance defaults to it). */
export function closePeriod(at: Date = now()): string {
  return addMonths(currentPeriod(at), -1);
}
